<template>
  <loader v-if="notifications === null" class="mt-6" />
  <panel v-else class="w-full h-full" with-header headerColour="secondary" textColour="primary">
    <template slot="header" class="bg-secondary text-primary">
      <h2 class="font-semibold uppercase">Alerts</h2>
    </template>
    <div class="slider-item" v-for="(notification, i) in networkNotifications" :key="i" v-show="activeIndex == i" v-if="networkNotifications.length">
      <div class="flex items-center">
        <div class="text-white w-24 h-24 rounded" v-if="notification.data.call_to_action_icon" :class="notification.data.call_to_action_icon_color">
          <icon :name="notification.data.call_to_action_icon" />
        </div>
        <div class="w-3/5" :class="{'pl-3':notification.data.call_to_action_icon}"><h3>{{ notification.data.subject }}</h3></div>
      </div>
      <div class="w-full pt-3" v-html="notification.data.description"></div>
      <div class="w-full flex flex-wrap mt-auto mb-2 mt-2" @click="clickNotification(notification.data.call_to_action_link)">
      <button class="rounded px-5 py-1 focus:outline-none mt-2 border-1 text-xs bg-secondary" type="button"
        >{{ notification.data.call_to_action_text }}
      </button>
      </div>
    </div>
    <div class="flex flex-1 items-center slider-item" v-if="!networkNotifications.length">
      <div class="flex items-center text-grey-light text-center leading-tight text-lg">
        There are no network alerts, please check back later
      </div>
    </div>
    <div class="flex items-center text-center justify-center mt-auto">
      <span
        class="p-2"
        v-for="(notification, i) in networkNotifications"
        :key="i"
        :class="[ i == activeIndex ? 'text-secondary' : 'text-grey-light' ]"
        @click="activeIndex = i"
      >
        <i class="fas fa-circle" v-if="networkNotifications.length > 1"></i>
      </span>
    </div>
  </panel>
</template>

<script>
// @ is an alias to /src
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'NetworkAlerts',
  data () {
    return {
      activeIndex: 0
    }
  },
  computed: {
    ...mapState(['system', 'notifications', 'selectedOffice']),

    networkNotifications () {
      let notifications = this.notifications.filter(notification => notification.notifiable_id === this.selectedOffice.network_id || (notification.notifiable_id === this.selectedOffice.client_id))
      notifications = notifications.filter(this.filterAvailableDates)
      return notifications
    }
  },
  created () {
    this.getNotifications()
  },
  methods: {
    ...mapActions(['fetchNotifications']),
    getNotifications () {
      this.fetchNotifications()
    },
    clickNotification: function (link) {
      if (link.startsWith('http')) {
        let tab = window.open()
        tab.location.href = link
        return
      }
      this.$router.replace(link)
    },
    filterAvailableDates: function (value) {
      let nowStamp = moment().unix()
      if (value.data) {
        if (value.data.start_at && value.data.expires_at) {
          let startDate = moment(value.data.start_at, 'YYYY-MM-DD HH:mm:ss').unix()
          let endDate = moment(value.data.expires_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return startDate < nowStamp && nowStamp < endDate
        } else if (value.data.start_at) {
          let startDate = moment(value.data.start_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return startDate < nowStamp
        } else if (value.data.expires_at) {
          let endDate = moment(value.data.expires_at, 'YYYY-MM-DD HH:mm:ss').unix()
          return nowStamp < endDate
        }
      }

      return true
    }
  }
}
</script>
